import React from 'react';

const Conductpro = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 text-gray-800 font-sans">
      <h1 className="text-4xl font-bold text-center mb-4">Conduit Pro</h1>
      
      <h3 className="text-2xl font-semibold mb-2">Overview</h3>
      <img
        src="https://inovaantage.com/wp-content/uploads/2024/02/utilities-home-energy.jpg"
        alt="Conduit Pro"
        className="w-full rounded-lg shadow-md mb-6"
      />

      <h3 className="text-2xl font-semibold mb-4">Associate Telecom Symbols</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <img
          src="https://inovaantage.com/wp-content/uploads/2024/03/conduit-pro-2.png"
          alt="Conduit Pro Symbol 1"
          className="rounded-lg shadow"
        />
        <img
          src="https://inovaantage.com/wp-content/uploads/2024/03/conduit-pro-4.png"
          alt="Conduit Pro Symbol 2"
          className="rounded-lg shadow"
        />
      </div>

      <h4 className="text-xl font-semibold mb-2">
        Introducing ConduitPro: Your Complete Solution for Underground Network Management
      </h4>
      <p className="text-lg leading-relaxed">
        In the realm of underground network management, precision, efficiency, and reliability are
        paramount. Meet ConduitPro, a revolutionary platform meticulously engineered to elevate the
        management of underground network systems to unprecedented levels of performance and innovation.
        <br /><br />
        At its core, ConduitPro is more than just software; it’s a comprehensive solution designed to
        address the intricate needs of modern utility and telecommunications networks. With a focus on
        seamless integration, intuitive usability, and unparalleled functionality, ConduitPro sets a new
        standard for underground network management.
      </p>
    </div>
  );
};

export default Conductpro;
